var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 244,
    viewBox: "0 0 244 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0008 103.633V0.775391H71.4212C80.0906 0.775391 86.9723 2.36723 92.0661 5.5509C97.16 8.6856 100.809 12.7264 103.013 17.6733C105.217 22.5713 106.319 27.6897 106.319 33.0285C106.319 36.7509 105.658 40.5223 104.336 44.3427C103.062 48.1142 101.029 51.5917 98.2375 54.7754C95.4947 57.9101 91.8947 60.457 87.4375 62.4162C83.0294 64.3264 77.6906 65.2815 71.4212 65.2815H47.0294V103.633H28.0008ZM47.0294 47.355H72.3028C75.8294 47.355 78.6457 46.6448 80.7518 45.2244C82.9069 43.755 84.4498 41.9182 85.3804 39.7142C86.311 37.5101 86.7763 35.2815 86.7763 33.0285C86.7763 30.9713 86.3355 28.8407 85.4539 26.6366C84.6212 24.3836 83.1518 22.4978 81.0457 20.9795C78.9396 19.4611 76.0253 18.7019 72.3028 18.7019H47.0294V47.355Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.776 243.224V140.367H210V158.441H159.805V181.069H189.707V199.143H159.805V225.004H210V243.224H140.776Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.968 140.367H0.817505V158.735H85.6008V243.224H103.968V158.735V140.367Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.703 103.633V96.2856H159.07V85.2652H243.266V103.633H140.703Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.703 0.775394V85.2652H159.07V0.775394H140.703Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.703 85.2652V96.2856H159.07V85.2652H140.703Z",
    fill: "white",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.e6dc246fc02b6a4ac74440046a909910.svg";
export { ForwardRef as ReactComponent };